import { createSlice } from "@reduxjs/toolkit";

/**
 * Store pour les enums métier Paul Janet
 *
 * TODO: Ajouter les types et reducers pour:
 * - Types de studios
 * - Statuts de candidature
 * - Équipements
 * - etc.
 */
export type EnumContextState = {
  // Placeholder pour futurs enums
};

const initialState: EnumContextState = {};

export const enumsSlice = createSlice({
  name: "enums",
  initialState,
  reducers: {
    setEnums: (_state, action) => {
      return action.payload;
    },
  },
});

export const { setEnums } = enumsSlice.actions;

export default enumsSlice.reducer;
